import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { formatDate } from "./formatDate";

const date = new Date();

export const exportPdf = {
  table: (data) => {
    // Use landscape orientation for wider tables
    let doc = new jsPDF("portrait", "pt", "a4");
    let y = 30;
    doc.setFont("helvetica", "normal");
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);

    // Calculate available width
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const availableWidth = pageWidth - 60;
    const currDate = formatDate.long(date.getTime() / 1000);

    if (!data.title) {
      data.title = " ";
    }

    const header = `${data.title} | Insights Export | Date Exported: ${currDate}`;
    const headerBlock = Math.ceil(
      (doc.splitTextToSize(header, 750).length * doc.getLineHeight(header)) /
        doc.internal.scaleFactor
    );

    doc.text(doc.splitTextToSize(header, 750), 30, y);
    y += headerBlock + 20;

    if (data.filter) {
      const filter = `Filtered By: \n\nBrands: ${data.filter.brands?.join(
        ", "
      )} \n\nChains: ${data.filter.chains?.join(
        ", "
      )} \n\nRevenue Center: ${data.filter.revCent?.join(
        ", "
      )}  \n\nPayment Type: ${data.filter.payType?.join(
        ", "
      )} \n\nDate: ${formatDate.longShort(
        data.filter.date.start
      )} to: ${formatDate.longShort(data.filter.date.end)}`;

      const filterBlock = Math.ceil(
        (doc.splitTextToSize(filter, availableWidth).length *
          doc.getLineHeight(filter)) /
          doc.internal.scaleFactor
      );

      doc.text(doc.splitTextToSize(filter, availableWidth), 30, y);
      y += filterBlock + 20;
    }

    data.body.forEach((body, key) => {
      // Define column styles for better formatting
      const columnStyles = {
        0: { cellWidth: 50 }, // Item No
        1: { cellWidth: 80 }, // Name
        2: { cellWidth: 40 }, // Qty
        3: { cellWidth: 80 }, // Price
        4: { cellWidth: 70 }, // Discount
        5: { cellWidth: 80 }, // Sales
        6: {
          cellWidth: 200, // Total Sales Per Outlet - wider
          fontSize: 8, // Smaller font for this column
          cellPadding: 3,
        },
      };

      autoTable(doc, {
        startY: y,
        theme: "striped",
        ...(key > 0 && { pageBreak: "always" }),
        margin: { top: 30, right: 30, bottom: 30, left: 30 },
        headStyles: {
          fillColor: "#212529",
          textColor: "#ffffff",
          lineColor: "#524e4e",
          fontSize: 9,
          cellPadding: 4,
        },
        bodyStyles: {
          fontSize: 8,
          cellPadding: 3,
          valign: "top", // Align text to top for multiline content
        },
        // columnStyles: columnStyles,
        head: body.head,
        body: body.body,
        // Handle text wrapping for long content
        didParseCell: function (data) {
          if (data.column.index === 6) {
            // Total Sales Per Outlet column
            data.cell.styles.cellWidth = 200;
            data.cell.styles.overflow = "linebreak";
            data.cell.styles.fontSize = 7;
          }
        },
      });

      // Update y position for next table
      y = doc.lastAutoTable.finalY + 20;
    });

    doc.save(
      "insightsExport_" +
        data.title.split(" ").join("_") +
        "_Report_" +
        date.getTime() +
        ".pdf"
    );
  },

  image: (data) => {
    const container = document.getElementById(data.body.id);
    const currDate = formatDate.long(date.getTime() / 1000);

    return html2canvas(container, {
      scale: 2, // Higher quality
      useCORS: true,
      allowTaint: true,
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");

      // Use landscape for image exports too if needed
      let doc = new jsPDF("portrait", "pt", "a4");
      let y = 30;
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(0, 0, 0);

      if (!data.title) {
        data.title = " ";
      }
      // Calculate available width
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const availableWidth = pageWidth - 60;

      const header =
        data.title + " | Insights Export | Date Exported: " + currDate;
      const headerBlock = Math.ceil(
        (doc.splitTextToSize(header, availableWidth).length *
          doc.getLineHeight(header)) /
          doc.internal.scaleFactor
      );

      doc.text(doc.splitTextToSize(header, availableWidth), 30, y);
      y += headerBlock + 20;

      if (data.filter) {
        const filter = `Filtered By: \n\nBrands: ${data.filter.brands?.join(
          ", "
        )} \n\nChains: ${data.filter.chains?.join(
          ", "
        )} \n\nRevenue Center: ${data.filter.revCent?.join(
          ", "
        )}  \n\nPayment Type: ${data.filter.payType?.join(
          ", "
        )} \n\nDate: ${formatDate.longShort(
          data.filter.date.start
        )} to: ${formatDate.longShort(data.filter.date.end)}`;

        const filterBlock = Math.ceil(
          (doc.splitTextToSize(filter, availableWidth).length *
            doc.getLineHeight(filter)) /
            doc.internal.scaleFactor
        );

        doc.text(doc.splitTextToSize(filter, availableWidth), 30, y);
        y += filterBlock + 20;
      }

      const width = doc.internal.pageSize.getWidth() - 60;
      const height = (canvas.height * width) / canvas.width;

      doc.addImage(imgData, "JPEG", 30, y, width, height);
      y += height + 20;

      data.body.table?.forEach((body, key) => {
        const columnStyles = {
          0: { cellWidth: 50 },
          1: { cellWidth: 80 },
          2: { cellWidth: 40 },
          3: { cellWidth: 80 },
          4: { cellWidth: 70 },
          5: { cellWidth: 80 },
          6: { cellWidth: 200, fontSize: 8, cellPadding: 3 },
        };

        autoTable(doc, {
          startY: y,
          theme: "striped",
          margin: { top: 30, right: 30, bottom: 30, left: 30 },
          headStyles: {
            fillColor: "#212529",
            textColor: "#ffffff",
            lineColor: "#524e4e",
            fontSize: 9,
          },
          bodyStyles: {
            fontSize: 8,
            cellPadding: 3,
            valign: "top",
          },
          //columnStyles: columnStyles,
          head: body.head,
          body: body.body,
          didParseCell: function (data) {
            if (data.column.index === 6) {
              data.cell.styles.overflow = "linebreak";
              data.cell.styles.fontSize = 7;
            }
          },
        });

        y = doc.lastAutoTable.finalY + 20;
      });

      doc.save(
        `insightsExport_${data.title.replace(
          /\s+/g,
          "_"
        )}_Report_${date.getTime()}.pdf`
      );
    });
  },
};
